import type { TFunction } from 'i18next';
import type { HeadlinePromoWidgetTitle } from '@/modules/promotions/templates/HeadlinePromoTemplate/helpers';

export interface IWidgetTitleContext {
  t: TFunction;
  levelNumber: number;
  levelName?: string;
}

type WidgetTitleResolver = (context: IWidgetTitleContext) => string;

const LEVEL_TITLE_FALLBACK = 'Level {{level}}: {{name}}';

const WIDGET_TITLE_RESOLVERS: Record<
  HeadlinePromoWidgetTitle,
  WidgetTitleResolver
> = {
  promo: ({ t }) => t('widget.title'),
  level: ({ t, levelNumber, levelName }) =>
    t('widget.level', {
      defaultValue: LEVEL_TITLE_FALLBACK,
      level: levelNumber,
      name: levelName,
    }),
};

export const getWidgetTitle = (
  context: IWidgetTitleContext,
  variant: HeadlinePromoWidgetTitle = 'promo'
) => WIDGET_TITLE_RESOLVERS[variant](context);
